// 下单
<template>
    <div>
        <van-nav-bar
            title="单据信息"
            left-text="返回"
            left-arrow
            @click-left="clickback"/>
        <van-swipe :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="itm in goods" :key="itm.version_id">
                <van-card
                    :price="itm.price"
                    :desc="itm.version_name"
                    :title="itm.prd_name"
                    :thumb="itm.img">
                    <div slot="num">
                        <van-stepper v-model="itm.qty"/>
                    </div>
                </van-card>
            </van-swipe-item>
        </van-swipe>

        <van-cell-group>
            <van-cell title="预约到店提货安装时间" icon="clock-o" />
            <van-cell :title="PlanDateText" is-link @click="showPlanDate=true" />
        </van-cell-group>

        <van-popup
            v-model="showPlanDate"
            round
            position="bottom"
            style="height: 90%; padding-top: 4px;">
            <van-tree-select
                :items="plandates"
                :active-id.sync="data.plan_time"
                :main-active-index.sync="plandateindex"
                height="55vw"
                @click-item="selPlanDate"/>
        </van-popup>

        <van-coupon-cell
            :coupons="Coupons"
            :chosen-coupon="chosenCoupon"
            @click="showCouponList = true"/>
        <van-popup
            v-model="showCouponList"
            round
            position="bottom"
            style="height: 90%; padding-top: 4px;">
            <van-coupon-list
                :coupons="Coupons"
                :chosen-coupon="chosenCoupon"
                :disabled-coupons="disabledCoupons"
                :show-exchange-bar="false"
                @change="onChangeCoupon"/>
        </van-popup>

        <van-cell-group>
            <van-field
                v-model="data.storedvaluecard_amount"
                clearable
                :label="`储值卡(${assert.storedvaluecard.amount_available})  `"
                placeholder="请输入使用金额"/>
        </van-cell-group>

        <van-field v-model="data.details" placeholder="请输入备注" />

        <van-panel title="联系方式" icon="location-o">
            <van-cell-group>
                <van-cell title="地址" :label="curshopinfo.city + curshopinfo.area + curshopinfo.address"/>
                <van-cell title="联系人" :value="curshopinfo.contact_name"/>
                <van-cell title="电话" :value="curshopinfo.contace_mobile"/>
            </van-cell-group>
        </van-panel>
        <van-loading vertical v-if="loading"/>
        <van-submit-bar
            :price="showAmount * 100"
            :disabled="goods.count"
            button-text="提交订单"
            @submit="onSubmit">
        </van-submit-bar>
    </div>
</template>

<script>
import {
    NavBar,
    Swipe,
    SwipeItem,
    Card,
    Panel,
    CellGroup,
    Cell,
    Field,
    Popup,
    CouponCell,
    CouponList,
    TreeSelect,
    SubmitBar,
    Stepper,
    Toast,
    Loading
} from 'vant'
import { getRangeDate, getCurDate } from '@/utils/dateutils'
import { AssertApi, CurShopInfoApi, OrderApi, UnifiedShopMarketOrderApi } from '@/api/market'
import { compareValues } from '@/utils/dateutils'
import wxshare from "@/utils/wxshare"
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Card.name]: Card,
        [Panel.name]: Panel,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Field.name]: Field,
        [CouponCell.name]: CouponCell,
        [CouponList.name]: CouponList,
        [Popup.name]: Popup,
        [TreeSelect.name]: TreeSelect,
        [SubmitBar.name]: SubmitBar,
        [Stepper.name]: Stepper,
        [Loading.name]: Loading
    },
    data() {
        return {
            goods: [],
            soure: '',
            loading: false,
            data: {
                delivery_style: true,
                plan_date: this.$moment(getCurDate()).format('YYYY-MM-DD'),
                plan_time: 0,
                details: null,
                deduction_id: null,
                deduction_amount: null,
                storedvaluecard: null,
                storedvaluecard_amount: null
            },
            curshopinfo: {
                city: '',
                area: '',
                address: '',
                contact_name: '',
                contace_mobile: ''
            },
            assert: {
                storedvaluecard: {id:null, amount_available: 0},
                coupons: [],
                vouchers: []
            },
            showCouponList: false,
            chosenCoupon: -1,
            Coupons: [],
            disabledCoupons: [],
            // disabledCoupons: [],
            plandatedays: getRangeDate(7, 'more'),
            plandatetimes: [
                {id: 0, text: '9:00-12:00'},
                {id: 1, text: '13:00-18:00'},
                {id: 2, text: '19:00-21:00'}
            ],
            showPlanDate: false,
            plandates: [],
            plandateindex: 0
        }
    },
    computed: {
        showAmount() {
            // 优惠券
            let amount = this.totalAmount()
            var deduction_amt = this.data.deduction_amount ? this.data.deduction_amount : 0
            var items_deduction_amt = 0
            this.goods.forEach((it) => {
                items_deduction_amt = items_deduction_amt + (it.deduction_amount ? it.deduction_amount : 0)
            })
            // 储值卡
            var storecard_amt = this.data.storedvaluecard_amount ? this.data.storedvaluecard_amount : 0
            return amount - deduction_amt - items_deduction_amt - storecard_amt
        },
        PlanDateText() {
            return this.data.plan_date + ' ' + this.plandatetimes[this.data.plan_time].text
        }
    },
    mounted: function() { 
        const query = JSON.parse(this.$route.query)
        this.source= query.source
        this.goods = query.data
        this.goods.forEach((it) => {
            it.deduction_style = null
            it.deduction_id = null
            it.deduction_amount = 0
        })
        const lst = []
        this.plandatedays.forEach((it) => {
            lst.push({
                id: it.id,
                text: it.name,
                children: this.plandatetimes
            })
        })
        this.plandates = lst
        this.getAssert()
        this.getShopInfo()
    },
    methods: {
        onChangeCoupon(index) {
            this.showCouponList = false;
            this.chosenCoupon = index;
            const it = this.Coupons[index]
            if (it.project_type === 0) {
                // 通用券
                this.data.deduction_id = it.id
                this.data.deduction_amount = it.money
                this.goods.forEach((it) => {
                    it.deduction_style = null
                    it.deduction_id = null
                    it.deduction_amount = 0
                })
            } else {
                // 其他
                this.data.deduction_id = null
                this.data.deduction_amount = 0
                const items = this.goods.filter((itm) => itm.price * itm.qty >= it.full_money 
                    && itm.version_id === it.project_id)
                if (items.length > 0) {
                    let item = items[0]
                    item.deduction_style = 1
                    item.deduction_id = it.id
                    item.deduction_amount = it.money
                }   
            }
            this.mathStoredvaluecard(it.money)
        },
        mathStoredvaluecard(deduction_amount) {
            if (this.assert.storedvaluecard.amount_available > 0) {
                const totalamount = this.totalAmount()
                if (this.assert.storedvaluecard.amount_available > totalamount - deduction_amount) {
                    this.data.storedvaluecard_amount = totalamount - deduction_amount
                } else {
                    this.data.storedvaluecard_amount = this.assert.storedvaluecard.amount_available
                }
            }
        },
        selPlanDate() {
            this.data.plan_date = this.plandatedays[this.plandateindex].id
            this.showPlanDate = false
        },
        getAssert() {
            var that = this
            that.axios.get(AssertApi).then((ret) => {
                if (ret.flag) {
                    ret = ret.details
                    // 储值卡
                    this.assert.storedvaluecard.id = ret.store_card? ret.store_card.id: null
                    this.assert.storedvaluecard.amount_available = ret.store_card? ret.store_card.amount_available: 0
                    // 优惠券
                    this.assert.coupons = ret.coupons
                    this.assert.vouchers = ret.vouchers  // 兑换券

                    this.getCoupons()
                } else {
                    toErrorPage(this, '错误', ret.info,null)
                }
                
            }).catch(function (error) {
                console.log(error)
            })
        },
        getCoupons() {
            const _coupons = []
            const totalamount = this.totalAmount()
            const curdate = getCurDate()
            this.assert.coupons.forEach((it) => {
                let valied = false
                if (it.project_type == 0) { // 通用券
                    if (it.full_money <= totalamount) {
                        valied = true
                    }
                } else {
                    var amt = 0 // 非通用券
                    const prods = this.goods.filter((p) => p.version_id == it.project_id)
                    if (prods.length > 0) {
                        prods.forEach((i) => {
                            amt = amt + i.qty * i.price
                        })
                        if (it.full_money <= amt) {
                            valied = true
                        }
                    }
                }
                if (it.begin_date <= curdate && it.end_date >= curdate) {
                    _coupons.push({
                        id: it.id,
                        project_type: it.project_type,
                        project_id: it.project_id,
                        full_money: it.full_money,
                        money: it.money,
                        available: valied,
                        condition: `消费满${it.full_money}\n优惠${it.money}`,
                        reason: '',
                        value: it.money * 100,
                        name: it.project_type===0 ? '通用券' : it.project_name,
                        startAt: Date.parse(new Date(it.begin_date)) / 1000,
                        endAt: Date.parse(new Date(it.end_date)) / 1000,
                        valueDesc: `${it.money}`,
                        unitDesc: '元'
                    })
                }
            })
            const result = _coupons.sort(compareValues('money', 'desc'))
            this.Coupons = result.filter((it) => it.available == true)
            this.disabledCoupons = result.filter((it) => it.available == false)
            if (this.Coupons.length > 0) {
                this.onChangeCoupon(0)
            } else {
                this.mathStoredvaluecard(0)
            }
        },
        getShopInfo() {
            var that = this
            that.axios.get(CurShopInfoApi).then((ret) => {
                that.curshopinfo = {
                    city: ret.details.city?ret.details.city:'',
                    area: ret.details.area?ret.details.area:'',
                    address: ret.details.address?ret.details.address:'',
                    contact_name: ret.details.contact_name?ret.details.contact_name:'',
                    contace_mobile: ret.details.contace_mobile?ret.details.contace_mobile:''
                }
            })
        },
        totalAmount() {
            // 总金额
            var amount = 0
            this.goods.forEach((it) => {
                amount = amount + it.qty * it.price //- (it.deduction_amount? it.deduction_amount:0)
            })
            return amount
        },
        onSubmit() {
            if (this.goods)
            var data = {
                items: this.goods,
                data: this.data,
                source: this.source
            }
            var that = this
            that.axios.post(OrderApi, data).then((ret) => {
                if (ret.flag) {
                    // Toast('下单完毕')
                    // that.$router.push('/home')
                    that.payment(ret.details.id)
                } else {
                    Toast(ret.info)
                }
            }).catch(function (error) {
                Toast(error)
            })
        },
        payment(order_id){
            wxshare.getJSSDK()
            var that = this
            const paymentdata = {
                "order": order_id
            }
            that.axios.post(UnifiedShopMarketOrderApi, paymentdata).then((ret) => {
                window.wx.ready(function(){
                    window.wx.chooseWXPay({
                        timestamp: ret.timeStamp, 
                        // 支付签名随机串，不长于 32 位
                        nonceStr: ret.nonceStr, 
                        package: ret.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: ret.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: ret.paySign, // 支付签名
                    success: function(res) {
                        console.log(res)
                        console.log('支付成功')
                        that.$router.push('/home')
                    },
                    fail: function(res) {
                        console.log(res)
                        console.log('支付失败')
                    },
                    complete: function(res) {
                        console.log(res, 'complete')
                    }
                    })
                })
            })

        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/user`)
            }
        }
    }
}
</script>